import { useMemo } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { type StripeElementsOptions } from '@stripe/stripe-js';

import { useFeatureFlag } from '@order/LaunchDarkly';

import { type StripePaymentProviderProps } from '../../types';
import {
  getMinimumAmount,
  getStripeKeyPrefix,
  loadStripeWithRetry,
} from '../../utils';

export const StripePaymentProvider = (props: StripePaymentProviderProps) => {
  const { children, amount, sessionId, publicKey, purchaseAttempt } = props;

  const paymentMethodConfiguration = useFeatureFlag(
    'permanent-stripe-payment-method-configuration-id',
  );

  const stripePromise = useMemo(
    () => loadStripeWithRetry(publicKey),
    [publicKey],
  );

  const options = useMemo<StripeElementsOptions>(
    () => ({
      amount: getMinimumAmount(amount),
      currency,
      mode,
      paymentMethodCreation,
      captureMethod,
      customerSessionClientSecret: sessionId,
      paymentMethodConfiguration,
    }),
    [amount, sessionId, paymentMethodConfiguration],
  );

  return (
    <Elements
      key={getStripeKeyPrefix(purchaseAttempt)}
      stripe={stripePromise}
      options={options}
    >
      {children}
    </Elements>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const currency = 'usd';
const mode = 'payment';
const paymentMethodCreation = 'manual';
const captureMethod = 'manual';
